<template>
  <header id="head" class="box-header">
    <div class="box-header_inner">
      <h1>
        <a v-on:click="lnk($event)"><img src="../assets/img/ttl_head.png" width="295" height="27" alt="モデルハウスレコメンド">
        </a>
      </h1>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    msg: String
  },
  methods: {
    lnk: function(){
      this.$router.push('/')
    }
  }
}
</script>